<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-title>
          <h3 class="headline mb-0 admin-header">Contacts</h3>
          <v-btn text icon color="grey lighten-1" @click="refresh()"
            ><v-icon>fas fa-sync</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-data-table
                :items="orgContacts"
                :loading="loading"
                :headers="headers"
                class="elevation-1"
              >
                <template v-slot:item.firstName="{item}">
                  <td>
                    <router-link to="" @click.native="editItem(item)">{{
                      item.firstName + " " + item.lastName
                    }}</router-link>
                  </td>
                </template>
                <template v-slot:item.updatedDate="{item}">
                  <td>{{ formatDateTime(item.updatedDate) }}</td>
                </template>
                <template v-slot:item.actions="{item}">
                  <td>
                    <v-tooltip bottom>
                      <template v-slot:activator="{on}">
                        <v-btn text icon @click="editItem(item)"  v-on="on"
                          style="height: 0px; width: 20px; padding-right:2px;">
                          <v-icon color="grey lighten-1" style="font-size: 18px;" >fas fa-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="item.contactType !== 'Admin'">
                      <template v-slot:activator="{on}">
                        <v-btn text icon @click="deleteItem(item)" v-on="on"
                          style="height: 0px; width: 20px;">
                          <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-trash</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <button class="btn btn-primary" @click="newItem()">Add Contact</button>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="showEditOrgContactDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Org Contact</span>
          </v-card-title>

          <v-card-text>
            <v-form v-model="validOrgContact" @submit.prevent>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                        v-if="editedItem.contactType === 'Admin'"
                        readonly disabled
                        v-model="editedItem.contactType"
                        label="Type *"
                    ></v-text-field>
                    <v-select
                      v-if="editedItem.contactType !== 'Admin'"
                      :items="contactTypes"
                      v-model="editedItem.contactType"
                      :rules="[rules.required]"
                      label="Type *"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                        v-model="editedItem.description"
                        label="Description"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      v-model="editedItem.firstName"
                      :rules="[rules.required]"
                      label="First Name *"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      v-model="editedItem.lastName"
                      :rules="[rules.required]"
                      label="Last Name *"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      v-model="editedItem.phoneNumber"
                      :rules="[rules.formatPhone]"
                      label="Phone"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      v-model="editedItem.email"
                      :rules="[rules.required, rules.formatEmail]"
                      label="Email *"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="mr-4" color="primary" outlined rounded  text @click.native="close"
              >Cancel</v-btn
            >
            <v-btn
              color="primary" rounded
              :disabled="!validOrgContact"
              @click.native="save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";
import Utility from "../CrossOrg/utility";
export default {
  data() {
    return {
      contactTypes: ["Security", "Financial", "Technical", "Other"],
      orgContacts: [],
      loading: false,
      search: "",
      headers: [
        { text: "Type", align: "left", sortable: true, value: "contactType" },
        { text: "Name", align: "left", sortable: true, value: "firstName" },
        { text: "Email", align: "left", sortable: true, value: "email" },
        { text: "Phone", align: "left", sortable: true, value: "phoneNumber" },
        {
          text: "Updated Date",
          align: "left",
          sortable: true,
          value: "updatedDate",
        },
        { text: "Actions", align: "left", sortable: false, value: "actions" },
      ],
      rules: {
        required: (value) => !!value || "Required.",
        numeric: (value) =>
          !value || Number.isInteger(+value) || "Invalid format",
         formatPhone: value => !value ||
            /^(\+|00|\(|)[1-9][0-9 \-\(\)\.]{7,32}$/.test(value)
            || 'Invalid Phone Number',
          formatEmail: value => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'Invalid Email'
      },
      valid: false,
      validOrgContact: false,
      showEditOrgContactDialog: false,
      originalItem: null,
      editedItem: {
        id: -1,
        contactType: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        description: "",
      },
      defaultItem: {
        id: -1,
        contactType: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        description: "",
      },
    };
  },
  methods: {
    async refresh() {
      this.loading = true;

      this.orgContacts = await this.$store.dispatch(
        "accountSettings/getOrgContacts"
      );

      this.loading = false;
    },
    async deleteItem(item) {
      if (confirm('Do you wish to delete (' + item.contactType + ') ' + item.firstName + ' ' + item.lastName + '?')) {
        await this.$store.dispatch('accountSettings/deleteOrgContact', item)
        await this.refresh();
      }
    },
    async editItem(item) {
      this.originalItem = item;
      this.editedItem = Object.assign({}, item);
      this.showEditOrgContactDialog = true;
    },
    newItem() {
      this.showEditOrgContactDialog = true;
    },
    close() {
      this.showEditOrgContactDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.originalItem = null;
      }, 300);
    },
    async save() {
      if (this.editedItem.id > -1) {
        await this.$store.dispatch("accountSettings/updateOrgContact", {
          orgContact: this.editedItem,
          patchObject: Utility.createPatchObject(
            this.originalItem,
            this.editedItem
          ),
        });
      } else {
        this.editedItem.id = null;
        await this.$store.dispatch(
          "accountSettings/insertOrgContact",
          this.editedItem
        );
      }
      this.close();

      await this.refresh();
    },
    formatDateTime(val) {
      if (!val) {
        return "";
      }
      return moment(val).isValid()
        ? moment(val).format("MM/DD/YYYY, h:mm:ss a")
        : val;
    },
    validateEmailFormat(value) {
      let regexDomain = new RegExp('^((?!@).)*@' + this.orgDomain + '$','i')
      let regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!this.isSU) {
        return regexDomain.test(value) || 'Format should match ...@' + this.orgDomain
      }
      return regexEmail.test(value) || 'Must be a valid email'
    }
  },
  watch: {
    orgContext: async function (val) {
      if (!val) {
        return;
      }

      this.loading = true;
      this.orgContacts = await this.$store.dispatch(
        "accountSettings/getOrgContacts"
      );
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters("user", {
      orgContext: "getOrgContext",
    }),
  },
  async created() {
    this.loading = true;
    this.orgContacts = await this.$store.dispatch(
      "accountSettings/getOrgContacts"
    );
    this.loading = false;
  },
};
</script>
